import * as React from "react"
import PropTypes from "prop-types"
import Navbar from "./navbar"
import Footer from "./footer"
import ContactButtons from "./ContactButtons"
import StructuredData from "./StructuredData"
import CookieConsentModal from "./cookieConsentModal"

const Layout = ({ location, title, children }) => {
  const rootPath = typeof __PATH_PREFIX__ !== 'undefined' ? `${__PATH_PREFIX__}/` : '/'
  const isRootPath = location?.pathname === rootPath

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <StructuredData />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ContactButtons />
      <CookieConsentModal />
    </div>
  )
}

Layout.propTypes = {
  location: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Layout
